import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { post } from '../../../ReactComponents/API';
import { ModalText } from '../../../ReactComponents/Modal/Modal';
import { SessionNotificationModal } from '../../../ReactComponents/Modal/SessionNotificationModal';

export interface RxSessionLogoutModalProps {
    bankIdLogoutUrl: string;
    ecomLogoutUrl: string;
    cartPageUrl: string;
    acknowledgeRxsWillRemoveUrl: string;
    validateBeforeShowing: () => Promise<boolean>;
}

export const RxSessionLogoutModal = ({
    bankIdLogoutUrl,
    ecomLogoutUrl,
    cartPageUrl,
    acknowledgeRxsWillRemoveUrl,
    validateBeforeShowing
}: RxSessionLogoutModalProps) => {
    const logout = (isEcomLogout: boolean) => {
        if (isEcomLogout) {
            window.location.href = ecomLogoutUrl;
        } else {
            window.location.href = bankIdLogoutUrl;
        }
    };

    const validate = (isEcomLogout?: boolean) => {
        return validateBeforeShowing().then((result) => {
            if (!result) {
                logout(isEcomLogout ?? false);
                return false;
            }

            return true;
        });
    };

    const onConfirm = (isEcomLogout: boolean) => {
        post(acknowledgeRxsWillRemoveUrl).finally(() => logout(isEcomLogout));
    };

    const onClose = (fromButton: boolean) => {
        if (!fromButton) {
            return;
        }

        window.location.href = cartPageUrl;
    };

    return (
        <SessionNotificationModal
            className="RxSessionModal__Logout"
            onConfirm={onConfirm}
            onClose={onClose}
            confirmLabel={getTranslation(keys['modal.rxSession.logout'])}
            cancelLabel={getTranslation(keys['modal.rxSession.goToCart'])}
            heading={getTranslation(keys['modal.rxSession.logoutHeading'])}
            additionalContent={
                <div className="RxSessionModal__ContentWrapper">
                    <div className="RxSessionModal__ImageWrapper">
                        <img src="/dist/assets/images/register.svg" alt="" className="RxSessionModal__Image" aria-hidden />
                    </div>
                    <ModalText>{getTranslation(keys['modal.rxSession.logoutBody'])}</ModalText>
                </div>
            }
            expirationDate={null}
            dismissKey=""
            maxNotificationThresholdMs={0}
            sessionEndedEvent={EventNames.RxLogoutRequest}
            ecomLogoutEvent={EventNames.EComLogoutRequest}
            validateBeforeShowing={validate}
        />
    );
};
